<template>
  <div class="pc-university">
    <!-- 院校头部面包屑部分 -->
    <BreadCrumb :data="breadcrumb" :title="'学者列表管理'" />
    <StatisticalPanel :whichModule="'scholar'" :data="overallData">
    </StatisticalPanel>
    <ModuleClassfication
      :title="titles"
      class="pc-news-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <ScholarTable />
  </div>
</template>
<script>
// 功能模块
import StatisticalPanel from "@/components/componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import ModuleClassfication from "@/components/componentSet/ModuleClassfication";
import ScholarTable from "./components/ScholarTable";
import {
  searchScholarTitle_Api,
  getScholarCount_Api,
  deleteScholarTitle_Api,
  addScholarTitle_Api,
  updateScholarTitle_Api,
  scholarSubjectDropDown_Api,
  addScholarSubject_Api,
  deleteScholarSubject_Api,
  updateScholarSubject_Api,
} from "@/apis/scholar.api";
export default {
  components: {
    BreadCrumb,
    ScholarTable,
    StatisticalPanel,
    ModuleClassfication,
  },
  data() {
    return {
      overallData: {
        title: "学者数据",
        count: [
          { name: "学者入库", count: null },
          { name: "WUPEN学者联盟", count: null },
        ],
      },
      titles: {
        module: "学者",
        class: [
          { name: "Titles", subTitles: [] },
          { name: "Subjects", subTitles: [] },
        ],
      },
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "学者列表", link: "/admin/scholarlist" },
      ];
    },
  },
  mounted() {
    getScholarCount_Api().then((res) => {
      this.$set(this.overallData.count[0], "count", res.data.scholar_count);
      this.$set(
        this.overallData.count[1],
        "count",
        res.data.wupen_scholar_count
      );
    });
    this.TitleSearch();
    this.SubjectSearch();
  },
  methods: {
    updateTopic(topic, callback) {
      if (topic.type == "Titles") {
        updateScholarTitle_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          title_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "Subjects") {
        updateScholarSubject_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          subject_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
    addTopic(topic, callback) {
      console.log(topic);
      if (topic.type == "Titles") {
        addScholarTitle_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "Subjects") {
        addScholarSubject_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
    deleteTopic(topic, callback) {
      if (topic.type == "Titles") {
        deleteScholarTitle_Api({
          title_id: topic.id,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "Subjects") {
        deleteScholarSubject_Api({
          subject_id: topic.id,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
    TitleSearch() {
      searchScholarTitle_Api().then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
    SubjectSearch() {
      scholarSubjectDropDown_Api().then((res) => {
        console.log(res);
        this.$set(this.titles.class[1], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/scholar/ScholarList.vue